import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArman = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#arman_svg__a)'>
      <path
        fill='#BE9C39'
        d='M15.336-.002c1.127.77 2.07 1.888 2.412 3.229.363 1.573-.018 3.28-.945 4.59a6.7 6.7 0 0 1-1.039 1.092c-1.157.991-2.543 1.694-3.614 2.79-.463.482-.893 1.023-1.132 1.656-.363.926-.358 2.008.09 2.904-1.207-.876-2.04-2.257-2.222-3.74-.045-.39-.061-.79.009-1.18.164-1.037.57-2.048 1.241-2.863q.419-.508.929-.922c.706-.569 1.515-.987 2.28-1.467.855-.584 1.592-1.364 2.059-2.295.364-.712.524-1.51.465-2.308-.06-.53-.307-1.011-.534-1.486M14.03 13.389c1.023-.248 2.116.593 2.209 1.626.025.42-.04.862-.277 1.22-.366.585-1.073.96-1.766.863a1.7 1.7 0 0 1-.917-.343c-.6-.459-.908-1.283-.717-2.019.178-.684.788-1.198 1.468-1.347'
      />
      <path
        fill='#031C45'
        d='M14.58 10.794c.293-.115.617-.183.93-.116.6.116 1.095.515 1.685.664.251.065.514.069.768.011.335-.096.556-.384.777-.633-.153.518-.335 1.092-.805 1.409-.375.22-.816.298-1.244.218-.61-.113-1.14-.459-1.725-.649-.474-.132-.95.072-1.376.265.18-.486.503-.954.993-1.168zm2.245 1.818a2.05 2.05 0 0 1 1.433.017 1.97 1.97 0 0 1 1.058 1.032c.22.5.275 1.055.277 1.596.016.584.198 1.194.62 1.614.256.207.575.308.864.455-.707.27-1.586.201-2.157-.327-.251-.257-.484-.547-.6-.891-.272-.765-.15-1.603-.41-2.37-.09-.248-.21-.496-.41-.674s-.447-.307-.675-.452m-11.572.65c1.402-.311 2.932.256 3.853 1.344.555.661.958 1.429 1.455 2.13.362.514.785.997 1.323 1.33.219.124.435.261.678.335.54.164 1.113.08 1.662.005-.494.532-1.11.961-1.804 1.185a3.6 3.6 0 0 1-1.745.105c-.765-.148-1.452-.574-1.999-1.118a5.7 5.7 0 0 1-.966-1.294c-.353-.618-.672-1.278-1.208-1.765-.597-.58-1.395-.982-2.236-1.006A2.37 2.37 0 0 0 3 14.835c.591-.71 1.342-1.338 2.251-1.574zm12.712 2.58c.398.65.597 1.43.512 2.191a2.97 2.97 0 0 1-.743 1.63c-.657.725-1.606 1.104-2.549 1.285-.662.144-1.309.415-1.823.863-.3.263-.54.584-.709.945-.167.392-.145.827-.201 1.242-.374-.62-.697-1.318-.669-2.06.064-1.257.939-2.403 2.094-2.875.762-.305 1.57-.477 2.32-.818.529-.236 1.019-.58 1.37-1.047.278-.396.338-.89.397-1.358'
      />
    </g>
    <defs>
      <clipPath id='arman_svg__a'>
        <path fill='#fff' d='M0-.002h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgArman)
export default ForwardRef
